export const filterBooleans = (obj: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    typeof value === 'boolean' && (result[key] = value);
  });
  return result;
};

export const isIndeterminate = (items: any) => {
  const checkIsIndeterminate =
    Object.values(filterBooleans(items)).some((value) => value) &&
    !Object.values(items).every((value) => value);
  return checkIsIndeterminate;
};

export const isAllCheck = (items: any) => {
  const checked = Object.values(filterBooleans(items)).every((value) => value);
  return checked;
};
